import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from 'src/app/demo/service/auth.service';

/**
  * @author Ministerio de cultura
  * @createdate 2024-12-29
  * Metodo que valida los menus de acuerdo al rol del usuario.
*/
export const roleGuard: CanActivateFn = (activatedRouteSnapshot: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const routePath = reconstructFullPath(activatedRouteSnapshot);
  const normalizedPath = normalizeRoutePath(routePath);
  const isFinalRoute = !activatedRouteSnapshot.firstChild;
  if (isFinalRoute) {
    const hasAccess = authService.decodeTokenUser().menu_data.some((menuPath: string) =>
      normalizeRoutePath(menuPath) === normalizedPath
    );
    if (hasAccess) {
      return true;
    } else {
      router.navigate(['unauthorized']);
      return false;
    }
  }
  return true;
};
/**
  * @author Ministerio de cultura
  * @createdate 2024-12-29
  * Metodo quita los parametros dinamicos de la url.
*/
const normalizeRoutePath = (path: string): string => {
  return path.replace(/\/:\w+/g, '');
};
/**
  * @author Ministerio de cultura
  * @createdate 2024-12-29
  * Metodo construye la url para su respectiva validacion.
*/
const reconstructFullPath = (snapshot: ActivatedRouteSnapshot): string => {
  let fullPath = '';
  while (snapshot) {
    if (snapshot.routeConfig?.path) {
      fullPath = `/${snapshot.routeConfig.path}${fullPath}`;
    }
    snapshot = snapshot.parent as ActivatedRouteSnapshot;
  }
  return fullPath;
};
